module.exports = __webpack_public_path__ + "hollow-circle/hollow-circle-8d4576cb7ca4f962a7bbfcdf20069579.svg";